export default "/images/23a18cd867f47216e2c9e5230fde207a.avif";